import React from 'react';
import { connect } from 'react-redux';
import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,Label,FormGroup, Input,InputGroup, InputGroupAddon,Card, CardBlock
} from 'reactstrap';
import { TabContent, TabPane, Nav, NavItem, NavLink,   CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import Spinner from 'react-spinkit';

import swal from 'sweetalert2';
import ReactTable from "react-table";
import "react-table/react-table.css";

import IconSave from 'react-icons/lib/md/save';
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/movimientocaclientes';

import Select from 'react-select';
import moment from 'moment';

import {api} from '../../actions/_request';
import ModalTablas from '../../components/catalogos/modal_tablas';

const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

const tipos = [
    {label: 'Traslado', value: 'Traslado'},
    {label: 'Retencion', value: 'Retencion'},
];
const factores = [
    {label: 'Tasa', value: 'Tasa'},
    {label: 'Cuota', value: 'Cuota'},
    {label: 'Exento', value: 'Exento'},
];
const impuestos = [
    {label: 'ISR', value: '001'},
    {label: 'IVA', value: '002'},
    // {label: 'IEPS', value: '003'},
];
const ieps = [
    {label: 'IEPS', value: '003'},
];

const unidades = [
    'Pieza',
    'Docena',
    'Par',
    'Paquete',
    'Kilo',
    'Gramo',
    'Litro',
    'Caja',
    'Metro',
    'Pie',
    'Pulgada',
    'Servicio',
    'No Aplica',
    'Galon',    
];

class FacturaModal extends React.Component
{
    constructor(props)
    {
        super(props)

        this.state = {
            producto: {  
                id : 0,
                codigo_item : '',
                item_id : 0,
                item_nombre : '', 
                tasaocuota : '1', 
                moneda_venta : '',
                unidad_compra : 0,
                unidad_venta : 0,
                tc : 0,
                descuento: 0,
                descuento_porc: 0,
                p_p1 : 0,
                p_p2 : 0,
                p_p3 : 0,
                p_p4 : 0,
                d_p1 : 0,
                d_p2 : 0,
                d_p3 : 0,
                d_p4 : 0,
                importe : 0,
                producto_descuento : 0,
                cantidad : 1,


                unidad_sat_nombre : "Actividad",
                unidad_sat_codigo:'ACT',
                unidad_sat_id:244,

                prod_serv_codigo:84111506,
                prod_serv_id:51542,
                prod_serv_nombre:"Servicios de facturación",


                codigo_sat_ieps:'003',
                ieps_venta_porc:0,
                factor_ieps:'Tasa',
                tipo_ieps:'Traslado',

                tipo_impuesto1:'Traslado',
                factor_impuesto1:'Tasa',
                codigo_sat_impuesto1:'002',
                impuesto1_porc:16,

                tipo_impuesto2:'Traslado',
                factor_impuesto2:'Tasa',
                codigo_sat_impuesto2:'001',
                impuesto2_porc:0,
            },
            action: 'save',
            no_existe :'0',
            modal:false,
            usuarios:[],
        };

        this.handleInputChange = this.handleInputChange.bind(this);      
        this.handleSubmit = this.handleSubmit.bind(this);      
        this.resetModal= this.resetModal.bind(this);            
        this.handleSelectChange= this.handleSelectChange.bind(this);
        
        this.toggle_modal= this.toggle_modal.bind(this);   
        this.retorno= this.retorno.bind(this);  
        this.ChangeCode= this.ChangeCode.bind(this);
        this.handleClose= this.handleClose.bind(this);
    }
   
    handleSelectChange(select, name) {
        const value = select === null ? null : select.value;
        this.setState({
            producto: {
                ...this.state.producto,
                [name]: value
            }
        });
    }

    componentDidMount()
    {    
        let prospectoid = this.props.prospectoid;
        let self = this;
        let renglon=this.props.producto_renglon;
              // console.log(renglon);
        if(prospectoid != null && prospectoid != self.state.producto.id)
        {
            if(prospectoid>0){
             
              api().get(`inventarioalmacen_codigo/${this.props.Almacen}/${renglon.codigo_item}`)
              .then(function(response)
              {
                    
                  if(response.status === 200)
                  {              
                    // console.log('renglon-->',renglon)
                      let producto = response.data;
                      producto.clave_ticket = renglon.clave_ticket; 
                      producto.ticket_id = renglon.ticket_id; 
                      producto.item_id = renglon.item_id;
                      producto.codigo_item= renglon.codigo_item;
                      producto.descripcion_item = renglon.descripcion_item;
                      producto.unidad_sat_codigo = renglon.unidad_sat_codigo;
                      producto.unidad_sat_id = renglon.unidad_sat_id;
                      producto.unidad_sat_nombre= renglon.unidad_sat_nombre;
                      producto.ud_venta = renglon.unidad_venta;
                      producto.cantidad = renglon.cantidad;
                      producto.precio = renglon.precio;
                      producto.descuento = renglon.descuento;
                      producto.descuento_porc = renglon.descuento_porc;
                      producto.importe = renglon.importe;


                      producto.impuesto1= renglon.impuesto1;
                      producto.impuesto1_porc= renglon.impuesto1_porc; 

                      producto.tipo_impuesto1= renglon.tipo_impuesto1;
                      producto.factor_impuesto1= renglon.factor_impuesto1;
                      producto.codigo_sat_impuesto1= renglon.codigo_sat_impuesto1;


                      producto.impuesto2= renglon.impuesto2;
                      producto.impuesto2_porc = renglon.impuesto2_porc;
                      producto.tipo_impuesto2= renglon.tipo_impuesto2;
                      producto.factor_impuesto2= renglon.factor_impuesto2;
                      producto.codigo_sat_impuesto2= renglon.codigo_sat_impuesto2;


                      producto.ieps_venta= renglon.ieps_venta;
                      producto.ieps_venta_porc = renglon.ieps_venta_porc;
                      producto.tipo_ieps= renglon.tipo_ieps;
                      producto.factor_ieps= renglon.factor_ieps;
                      producto.codigo_sat_ieps= renglon.codigo_sat_ieps;
                      producto.total = renglon.total;
                      producto.utilidad = 0;
                      producto.comision= 0;
                      producto.comision_porc = renglon.comision;
                      producto.prod_serv_id = renglon.prod_serv_id;
                      producto.prod_serv_codigo = renglon.prod_serv_codigo;  

                      switch(self.props.moneda){
                        case 'MXN':
                          if(parseInt(producto.moneda_venta) == 1){
                            producto.p_p1 = producto.credito;
                            producto.p_p2 = producto.contado;
                            producto.p_p3 = producto.p3;
                            producto.p_p4 = producto.p4;
                            producto.d_p1 = self.trunc(producto.credito/self.props.tc,2);
                            producto.d_p2 = self.trunc(producto.contado/self.props.tc,2);
                            producto.d_p3 = self.trunc(producto.p3/self.props.tc,2);
                            producto.d_p4 = self.trunc(producto.p4/self.props.tc,2);
                          }else{
                            producto.d_p1 = producto.credito;
                            producto.d_p2 = producto.contado;
                            producto.d_p3 = producto.p3;
                            producto.d_p4 = producto.p4;
                            producto.p_p1 = self.trunc(producto.credito*self.props.tc,2);
                            producto.p_p2 = self.trunc(producto.contado*self.props.tc,2);
                            producto.p_p3 = self.trunc(producto.p3*self.props.tc,2);
                            producto.p_p4 = self.trunc(producto.p4*self.props.tc,2);
                          }
                        break;
                        case 'USD':
                          if(parseInt(producto.moneda_venta) == 1){
                            producto.p_p1 = producto.credito;
                            producto.p_p2 = producto.contado;
                            producto.p_p3 = producto.p3;
                            producto.p_p4 = producto.p4;
                            producto.d_p1 = self.trunc(producto.credito/self.props.tc,2);
                            producto.d_p2 = self.trunc(producto.contado/self.props.tc,2);
                            producto.d_p3 = self.trunc(producto.p3/self.props.tc,2);
                            producto.d_p4 = self.trunc(producto.p4/self.props.tc,2);
                          }else{
                            producto.d_p1 = producto.credito;
                            producto.d_p2 = producto.contado;
                            producto.d_p3 = producto.p3;
                            producto.d_p4 = producto.p4;
                            producto.p_p1 = self.trunc(producto.credito*self.props.tc,2);
                            producto.p_p2 = self.trunc(producto.contado*self.props.tc,2);
                            producto.p_p3 = self.trunc(producto.p3*self.props.tc,2);
                            producto.p_p4 = self.trunc(producto.p4*self.props.tc,2);
                          }
                        break;
                      }
                      self.setState({
                          producto: producto,
                          action: 'update',
                          no_existe:'0'
                      });

                  }


              });             
            }else{
              self.setState({
                          producto: renglon,
                          action: 'update',
                          no_existe:'1'
                      });
            }

        }
        else
        {       
            // console.log('reset')     
            this.resetModal();
        }

      // console.log('descuento Props--->',this.props.descuento);
      // console.log('descuento final--->',this.props.descuento?this.props.descuento:0);

        let tc = this.props.tc;
        let descuento = this.props.descuento?this.props.descuento:0;
        let {producto} = this.state;
        producto.tc = tc;
        producto.descuento = descuento;
        this.setState({
          producto : producto
        })
    }

     handleClose (event) {
     
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        let campo="";
        let tabla=""

        
         switch (name) {
            case "codigo_item":                  
                campo = "item_id";
                tabla="/factura_producto_codigo/"+this.props.factura_id;
                break;
            case "almacen_codigo":                  
	            campo = "almacen_id";
	            tabla="/busqueda_almacen";
	            break;    
            case "intermediario_id":                  
              campo = "intermediario_id";
              tabla="/busqueda_usuario";
              break; 
            case "prod_serv_codigo":
              campo="prod_serv_id";
              tabla = "/sat/productos_servicios_codigo";
            break;
            case "unidad_sat_codigo":
              campo = "unidad_sat_codigo";
              tabla = "/sat/unidades_codigo";
              break;
        }
        let self =this;
        if(value!=""){
            api().get(`${tabla}/${value}`)
            .then(function(response)
            {                  
                if(response.status === 200)
                { 
                    let vaciar=0;
                     if(Object.keys(response.data).length > 0){
                        
                        let  retorno=response.data;
                        self.retorno(retorno,campo,vaciar,value);
                       
                       
                     }  else{
                         vaciar=1
                         swal("Oops..", "No Existe el Codigo");
                          self.retorno(response.data,campo,vaciar,value);
                     }        
                   
                }

            });
        }else{
          if(name=='codigo_item'){
                this.resetModal();
          }else{
              self.retorno([],campo,1,value);
          }
              
             
        }
   }

    ChangeCode(event) {
        let {producto} = this.state;
        const target    = event.target;
        let value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        if(target.type === 'checkbox'){
            value='0';
            if(target.checked)
                value='1';
        }
         producto.descripcion_item="";
         producto.codigo_item ="No Existe";
         if(value=='0')
         producto.codigo_item ="";
        
            this.setState({
            producto:producto,
            [name] : value
        }); 
    }

    retorno(objeto,campo,vacio=0,valor=""){
       	// console.log('renglon---->',objeto);
        let {producto} = this.state;
        let self =this;

        switch (campo) {
            case "item_id":
                  producto[campo] = objeto.item_id;
                  producto.descripcion_item=objeto.label?objeto.label:objeto.nombre;
                  producto.codigo_item=objeto.codigo_interno;
                  producto.item_costo=objeto.costo;
                  producto.item_existencia=objeto.existencia;
                  producto.item_precio1 = objeto.credito;
                  producto.item_precio2 = objeto.contado;
                  producto.impuesto_venta1 = objeto.impuesto_venta1;
                  producto.impuesto_venta2 = objeto.impuesto_venta2;
                  producto.moneda_venta = objeto.moneda_venta;
                  producto.p3 = objeto.p3;
                  producto.p4 = objeto.p4; 
                  producto.unidad_compra = objeto.unidad_compra;
                  producto.unidad_venta = objeto.unidad_venta;
                  producto.unidad_sat_nombre = objeto.unidad_sat_nombre;
                  producto.unidad_sat_id = objeto.unidad_sat_id;
                  producto.factor_es = objeto.factor_es;
                  producto.ieps_venta_porc = objeto.ieps_venta;
                  producto.impuesto1_porc= objeto.impuesto1_porc;
                  producto.impuesto2_porc = objeto.impuesto2_porc;
                  producto.prod_serv_codigo = objeto.prod_serv_codigo;
                  producto.prod_serv_id = objeto.prod_serv_id;
                  producto.prod_serv_nombre = objeto.prod_serv_nombre;
                  producto.unidad_sat_codigo = objeto.unidad_codigo;
                  producto.factor_tasacuota = objeto.factor_tasacuota;
                  producto.factor_impuesto1 = objeto.factor_impuesto1;
                  producto.tipo_impuesto1 = objeto.tipo_impuesto1;
                  producto.codigo_sat_impuesto1 = objeto.codigo_sat_impuesto1;
                  producto.factor_impuesto2 = objeto.factor_impuesto2;
                  producto.tipo_impuesto2 = objeto.tipo_impuesto2;
                  producto.codigo_sat_impuesto2 = objeto.codigo_sat_impuesto2;
                  producto.factor_ieps = objeto.factor_ieps;
                  producto.tipo_ieps = objeto.tipo_ieps;
                  producto.codigo_sat_ieps = objeto.codigo_sat_ieps;
                  producto.clave_ticket='';
                  producto.ticket_id=0;
                  producto.precio=objeto.precio;
                  // console.log('producto desde codigo--->',producto);
                  // console.log('producto bd--->',objeto);
                  // this.convertirValores(objeto);
                  // this.selectPrecio(objeto);
                  
                  break;
            case "almacen_id":
                producto[campo] = objeto.value?objeto.value:objeto.id;
                producto.almacen_nombre=objeto.label?objeto.label:objeto.nombre;
                producto.almacen_codigo= objeto.codigo;
                break;
            case "intermediario_id":
              producto[campo] = objeto.value?objeto.value:objeto.id;
              producto.intermediario_nombre = objeto.label?objeto.label:objeto.nombre;
              this.selectComision(objeto);
              break;

            case "prod_serv_id": 
                // console.log(' codigo sat')
                producto[campo] = objeto.value?objeto.value:objeto.id;
                producto.prod_serv_nombre = objeto.descripcion;
                producto.prod_serv_codigo = objeto.clave;
              break;
            case "unidad_sat_codigo":
              producto[campo] = objeto.codigo;
              producto.unidad_sat_nombre = objeto.nombre;
              producto.unidad_sat_id = objeto.value?objeto.value:objeto.id;
        }  

       if(vacio==1){
        // console.log('vaciar')
        if(campo == 'item_id')
        	producto.codigo_item='';
        else{
        	producto.almacen_codigo='';
        }
        
        producto[campo] =0;

       }
         self.setState({
            producto : producto,           
            modal:false,         
        })
    }

    selectComision(obj){
      let {producto} = this.state;
      switch(parseInt(this.props.codigo_comision)){
        case 1:
          producto.comision = obj.com_1;
          break;
        case 2:
          producto.comision = obj.com_2;
          break;
        case 3:
          producto.comision = obj.com_3;
          break;
        case 4:
          producto.comision = obj.com_4;
          break;
      }
    }

    convertirValores(objeto){
      let {producto} = this.state;
      // console.log(this.props.moneda)
      switch(this.props.moneda){
        case 'MXN':
          if(parseInt(objeto.moneda_venta) == 1){
            producto.p_p1 = objeto.credito;
            producto.p_p2 = objeto.contado;
            producto.p_p3 = objeto.p3;
            producto.p_p4 = objeto.p4;
            producto.d_p1 = this.trunc(objeto.credito/this.props.tc,2);
            producto.d_p2 = this.trunc(objeto.contado/this.props.tc,2);
            producto.d_p3 = this.trunc(objeto.p3/this.props.tc,2);
            producto.d_p4 = this.trunc(objeto.p4/this.props.tc,2);
          }else{
            producto.d_p1 = objeto.credito;
            producto.d_p2 = objeto.contado;
            producto.d_p3 = objeto.p3;
            producto.d_p4 = objeto.p4;
            producto.p_p1 = this.trunc(objeto.credito*this.props.tc,2);
            producto.p_p2 = this.trunc(objeto.contado*this.props.tc,2);
            producto.p_p3 = this.trunc(objeto.p3*this.props.tc,2);
            producto.p_p4 = this.trunc(objeto.p4*this.props.tc,2);
          }
        break;
        case 'USD':
          if(parseInt(objeto.moneda_venta) == 1){
            producto.p_p1 = objeto.credito;
            producto.p_p2 = objeto.contado;
            producto.p_p3 = objeto.p3;
            producto.p_p4 = objeto.p4;
            producto.d_p1 = this.trunc(objeto.credito/this.props.tc,2);
            producto.d_p2 = this.trunc(objeto.contado/this.props.tc,2);
            producto.d_p3 = this.trunc(objeto.p3/this.props.tc,2);
            producto.d_p4 = this.trunc(objeto.p4/this.props.tc,2);
          }else{
            producto.d_p1 = objeto.credito;
            producto.d_p2 = objeto.contado;
            producto.d_p3 = objeto.p3;
            producto.d_p4 = objeto.p4;
            producto.p_p1 = this.trunc(objeto.credito*this.props.tc,2);
            producto.p_p2 = this.trunc(objeto.contado*this.props.tc,2);
            producto.p_p3 = this.trunc(objeto.p3*this.props.tc,2);
            producto.p_p4 = this.trunc(objeto.p4*this.props.tc,2);
          }
        break;

        this.setState({
          producto : producto
        })
      }
    }

    trunc (sVal, nDec = 0) {
      // var s = x.toString()
      // var l = s.length
      // var decimalLength = s.indexOf('.') + 1
      // var numStr = s.substr(0, decimalLength + posiciones)
      // return Number(numStr)


        var num = parseFloat(sVal); 
        // var s = "0.00"; 
        // if (!isNaN(n)){ 
        //  n = Math.round(n * Math.pow(10, nDec)) / Math.pow(10, nDec); 
        //  s = String(n); 
        //  s += (s.indexOf(".") == -1? ".": "") + String(Math.pow(10, nDec)).substr(1); 
        //  s = s.substr(0, s.indexOf(".") + nDec + 1); 
        // } 
         var s = num.toFixed(2);

        return parseFloat( s); 
    }

    selectPrecio(objeto){
      let {producto} = this.state;
      switch(this.props.codigo_precio){
          case 1:
            if(this.props.moneda=='MXN'){
              producto.precio = producto.p_p1;
            }
            else{
              producto.precio = producto.d_p1;
            }
          break;
          case 2:
            if(this.props.moneda=='MXN'){
              producto.precio = producto.p_p2;
            }
            else{
              producto.precio = producto.d_p2;
            }
          break;
          case 3:
            if(this.props.moneda== 'MXN'){
              producto.precio = producto.p_p3;
            }
            else{
              producto.precio = producto.d_p3;
            }
          break;
          case 4:
            if(this.props.moneda== 'MXN' ){
              producto.precio = producto.p_p4;
            }
            else{
              producto.precio = producto.d_p4;
            }
          break;
        }

      this.setState({producto:producto})
    }

    toggle_modal(index=0,catalogo="",campo=""){  

        this.setState({
            modal : !this.state.modal,
            titulo:catalogo,
            tabla_modal:index,
            campo_modal:campo,         
        })
    }

    resetModal(){

        this.setState({
            producto: {  
                id : 0,
                codigo_item : '',
                descripcion_item:'',
                item_id : 0,
                item_nombre : '', 
                tasaocuota : '1', 
                moneda_venta : '',
                unidad_compra : 0,
                unidad_venta : 0,
                tc : 0,
                descuento: 0,
                 descuento_porc: 0,
                p_p1 : 0,
                p_p2 : 0,
                p_p3 : 0,
                p_p4 : 0,
                d_p1 : 0,
                d_p2 : 0,
                d_p3 : 0,
                d_p4 : 0,
                importe : 0,
                producto_descuento : 0,
                cantidad : 1,
                

                unidad_sat_nombre : "Actividad",
                unidad_sat_codigo:'ACT',
                unidad_sat_id:244,

                prod_serv_codigo:84111506,
                prod_serv_id:51542,
                prod_serv_nombre:"Servicios de facturación",


                codigo_sat_ieps:'003',
                ieps_venta_porc:0,
                factor_ieps:'Tasa',
                tipo_ieps:'Traslado',

                tipo_impuesto1:'Traslado',
                factor_impuesto1:'Tasa',
                codigo_sat_impuesto1:'002',
                impuesto1_porc:16,

                tipo_impuesto2:'Traslado',
                factor_impuesto2:'Tasa',
                codigo_sat_impuesto2:'001',
                impuesto2_porc:0,
            },
            action: 'save',
             activeTab: '1',
        });
        
    }

    handleInputChange(event) {
        let {producto} = this.state;
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

        producto[name] = value;
     
        this.setState({
            producto : producto
        });
    }

    objeto_mayusculas(objeto){
         // for (var key in objeto) {
         //        if (objeto.hasOwnProperty(key)) {
         //            // var valor=String(objeto[key]).toUpperCase();                 
         //            // console.log('valor---->',valor)
                     
         //                 objeto[key] = String(objeto[key]).toUpperCase() ;
         //                 if( String(objeto[key]).toUpperCase()==='NULL')
         //                    objeto[key] ='';
                     
         //            // console.log(key + " = " + objeto[key]);
         //        }
         //      }
              return objeto;
    }
   
   

  handleSubmit(evt)
  {
    evt.preventDefault();
    let {producto} = this.state;
    let action=this.state.action;
    let newarray = [];
    let save=true;
    let dato="";
    let self = this;    

    

    let check = ['precio','prod_serv_id','unidad_sat_id','cantidad'];

    for(let i in check) {

        let key = check[i];

        let value = producto[key];
        dato=key;

        if(value == 0 || value == null){
            save = false;
            break;
        }
            
    } 

 	  producto.unidad_venta= unidades[producto.unidad_venta];

    let tempCantidad = parseFloat(producto.cantidad);
    let tempPrecio = parseFloat(producto.precio);
    let tempDescuento = parseFloat(producto.descuento_porc);
    let tempieps = parseFloat(producto.ieps_venta_porc);
    let tempImpto1 = parseFloat(producto.impuesto1_porc);
    let tempImpto2 = parseFloat(producto.impuesto2_porc);

    let tempImporte = tempCantidad * tempPrecio;

    let descuentoItem = this.trunc((tempImporte * tempDescuento / 100),2);  
    let subTotal = this.trunc((tempImporte - descuentoItem),2) ;

    let iepsItem = this.trunc(( subTotal * tempieps / 100),2) ; 

    let subIeps = subTotal + iepsItem;

    let tempimpuesto1 = this.trunc((subIeps * tempImpto1 / 100),2) ;
    let tempimpuesto2 = this.trunc((subIeps * tempImpto2 / 100),2) ;

    let tempImpuestos = tempimpuesto1 + tempimpuesto2;

    let tempTotal = subTotal + iepsItem + tempImpuestos;


    producto.importe = this.trunc(tempImporte,2);
    producto.descuento = this.trunc(descuentoItem,2);
    producto.subtotal = this.trunc(subTotal,2);
    producto.ieps_venta = this.trunc(iepsItem,2);
    producto.impuestos = this.trunc(tempImpuestos,2);
    producto.impuesto1 = this.trunc(tempimpuesto1,2);
    producto.impuesto2 = this.trunc(tempimpuesto2,2);
    producto.total = this.trunc(tempTotal,2);
    // producto.clave_ticket='';
    // producto.ticket_id=0;


    console.log('importe--->',tempImporte);
    console.log('subtotal --->',subTotal);
    console.log('ieps --->',iepsItem);
    console.log('impuestos ---> ',tempImpuestos);
    console.log('producto --->',producto);
     
    if(save){
      this.props.retorno(producto);
      this.resetModal();
      this.props.alerta({
        mensaje:"Producto Agregado Correctamente",
        tipo:"success",
        creacion:moment().format('Y-MM-DD H:m:s'),
      });
     
    }
    else{
      this.props.alerta({
        mensaje:"Verifique la informacion",
        tipo:"warning",
        creacion:moment().format('Y-MM-DD H:m:s'),
      });
    }
  }
  

    render()
    {

        let {producto}=this.state;
  		  let no_existe=this.state.no_existe === "0" ? true : false;

  		let editar= null

        return(

           <Modal isOpen={this.props.open} toggle={this.props.toggle} className="default modal-lg modal-80 modal_cliente">
                <form onSubmit={this.handleSubmit} >
                <ModalHeader toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                   <div className="row ">
                   		<div className="col-12 col-sm-3"> 
                        <div className="form-group">
                            <label className="">codigo:</label><br/>
                            <Input
                            placeholder=""
                            type="text"
                            name="codigo_item"
                            value={producto.codigo_item}
                            onChange={ this.handleInputChange}
                            onBlur={this.handleClose}
                            className="input_button_sm"
                            style={{width : '130px'}}
                            readOnly={!no_existe}
                            disabled={!no_existe}

                            />
                            <Button onClick={ (button) => { this.toggle_modal(35,"Productos","item_id") } } >...</Button>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group">
                          <label className>Descripcion: </label>
                          <Input
                            rows={2}                            
                            type="textarea"
                            name="descripcion_item"
                            className="texto_normal"
                            maxLength={499}
                            value={producto.descripcion_item} 
                            onChange={ this.handleInputChange }
                            required
                            readOnly={no_existe}
                            />
                        </div>     
                      </div>
                      <div className="col-12 col-sm-3">
                        <div className="form-group" >
                            <Label > TC: $ {producto.tc}</Label>
                            <br/>
                            <label >
                                        <input type="checkbox"
                                        name="no_existe" 
                                        checked={this.state.no_existe === "0" ? false : true}
                                        onChange={this.ChangeCode} 
                                        />&nbsp;&nbsp; No Existe
                                    </label>
                        </div>
                      </div>
                   </div>
                    <div className="row">
                      <div className="col-12 col-sm-12 div_titulo  " style={{fontSize : '11px'}}>
                        <h1><span><b>INFO</b></span></h1>
                        <div className="row mt-4">
                          <div className="col-12 col-sm-3">
                            <div className="form-group">
                              <b>M.n</b>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Precio 1:
                              <Label className="ml-3">{producto.p_p1}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Precio 2:
                              <Label className="ml-3">{producto.p_p2}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Precio 3:
                              <Label className="ml-3">{producto.p_p3}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Precio 4:
                              <Label className="ml-3">{producto.p_p4}</Label>
                            </div>
                          </div>
                          <div className="col-12 col-sm-3">
                            <div className="form-group">
                              <b>Dolares</b>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Precio 1:
                              <Label className="ml-3">{producto.d_p1}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Precio 2:
                              <Label className="ml-3">{producto.d_p2}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Precio 3:
                              <Label className="ml-3">{producto.d_p3}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Precio 4:
                              <Label className="ml-3">{producto.d_p4}</Label>
                            </div>
                          </div>
                          <div className="col-12 col-sm-3">                            
                            <div className="form-group" style={{display : 'flex'}}>
                              unid/Compra:
                              <Label className="ml-3">{unidades[producto.unidad_compra]}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              unid/Venta:
                              <Label className="ml-3">{unidades[producto.unidad_venta]}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              Factor E/S:
                              <Label className="ml-3">{producto.factor_es}</Label>
                            </div>
                            <div className="form-group" style={{display : 'flex'}}>
                              <Label className=""> Moneda de venta del catalogo : {producto.moneda_venta !== ''? producto.moneda_venta == 1 ? ' PESOS' : ' DOLARES' : ''}</Label>
                            </div>
                          </div>
                          <div className="col-12 col-sm-3">
                            <div className="form-group" style={{display : 'flex'}}>
                                T.C.:
                                <Label className="ml-3">{producto.tc}</Label>
                              </div>
                              <div className="form-group" style={{display : 'flex'}}>
                                Impuesto 1:
                                <Label className="ml-3">{producto.impuesto1_porc}</Label>
                              </div>
                              <div className="form-group" style={{display : 'flex'}}>
                                Impuesto 2:
                                <Label className="ml-3">{producto.impuesto2_porc}</Label>
                              </div>
                              <div className="form-group" style={{display : 'flex'}}>
                                Ultimo costo:
                                <Label className="ml-3">{producto.item_costo}</Label>
                              </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-12 col-sm-2">
                            <div className="form-group">
                              cantidad:
                              <Input
                                type="number"
                                step="any"
                                onChange={this.handleInputChange}
                                name={'cantidad'}
                                value={producto.cantidad}
                                style={{width : '130px'}}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-2">
                            <div className="form-group">
                              Precio:
                              <Input
                                type="number"
                                step="any"
                                onChange={this.handleInputChange}
                                name={'precio'}
                                value={producto.precio}
                                style={{width : '130px'}}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-2">
                            <div className="form-group">
                              Descuento:
                              <Input
                                type="text"
                                onChange={this.handleInputChange}
                                name={'descuento_porc'}
                                value={producto.descuento_porc}
                                style={{width : '130px'}}
                                required
                              />
                            </div>
                          </div>
                          <div className="col-12 col-sm-2">
                            <div className="form-group">
                              <label className="-block">Intermediario:</label><br/>
                              <Input
                              placeholder=""
                              type="text"
                              name="intermediario_id"
                              value={producto.intermediario_id}
                              onChange={ this.handleInputChange}
                              onBlur={this.handleClose}
                              className="input_button_sm"
                              />
                              <Button onClick={ (button) => { this.toggle_modal(31,"Intermediario","intermediario_id") } } >...</Button>
                            </div>
                          </div>
                          <div className="col-12 col-sm-2">
                            <div className="form-group" >
                              <label className="mt-2">
                              {producto.intermediario_nombre}
                              </label>
                              <Label>Comision:</Label>
                              <Label>{producto.comision}</Label>
                            </div>
                          </div>
                          <div className="col-12 col-sm-3">
                          <div className="form-group">
                            <label className="">Cod. Prod. y Serv. SAT:</label><br/>
                            <Input
                            placeholder=""
                            type="text"
                            name="prod_serv_codigo"
                            value={producto.prod_serv_codigo}
                            onChange={ this.handleInputChange}
                            onBlur={this.handleClose}
                            className="input_button_sm"
                            style={{width : '130px' }}
                            required
                            disabled
                           
                            />
                            <Button onClick={ (button) => { this.toggle_modal(12,"Prod. y serv. SAT","prod_serv_id") } } >...</Button>
                          </div>
                        </div>
                        <div className="col-12 col-sm-3">
                          <div className="form-group">
                            <Label className='mt-3'>{producto.prod_serv_nombre}</Label>
                          </div>
                        </div>
                        <div className="col-12 col-sm-3">
                          <div className="form-group">
                              <label className="">Clave unidad SAT:</label><br/>
                              <Input
                              placeholder=""
                              type="text"
                              name="unidad_sat_codigo"
                              value={producto.unidad_sat_codigo}
                              onChange={ this.handleInputChange}
                              onBlur={this.handleClose}
                              className="input_button_sm"
                              style={{width : '130px' }}
                              required
                              disabled
                              />
                              <Button onClick={ (button) => { this.toggle_modal(10,"Productos","unidad_sat_codigo") } } >...</Button>
                          </div>
                        </div>
                        <div className="col-12 col-sm-3">
                          <div className="form-group">
                            <Label className='mt-3'>{producto.unidad_sat_nombre}</Label>
                          </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group">
                              <Label className='mt-3'>Impuesto 1:</Label>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Tipo</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="tipo_impuesto1"
                                    options={tipos } 
                                    value={producto.tipo_impuesto1}
                                    onChange={ (select) => { this.handleSelectChange(select, 'tipo_impuesto1') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Impuesto</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="codigo_sat_impuesto1"
                                    options={impuestos } 
                                    value={producto.codigo_sat_impuesto1}
                                    onChange={ (select) => { this.handleSelectChange(select, 'codigo_sat_impuesto1') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Factor</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="factor_impuesto1"
                                    options={factores } 
                                    value={producto.factor_impuesto1}
                                    onChange={ (select) => { this.handleSelectChange(select, 'factor_impuesto1') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                          <div className="col-12 col-sm-3">
                            <div className="form-group">
                              <Label className=''>Porcentaje:</Label>
                                <Input
                                  type="number"
                                  step="any"
                                  onChange={this.handleInputChange}
                                  name={'impuesto1_porc'}
                                  value={producto.impuesto1_porc}
                                  style={{width : '130px'}}
                                  required
                                />
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="form-group">
                              <Label className='mt-3'>Impuesto 2:</Label>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Tipo</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="tipo_impuesto2"
                                    options={tipos } 
                                    value={producto.tipo_impuesto2}
                                    onChange={ (select) => { this.handleSelectChange(select, 'tipo_impuesto2') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Impuesto</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="codigo_sat_impuesto2"
                                    options={impuestos } 
                                    value={producto.codigo_sat_impuesto2}
                                    onChange={ (select) => { this.handleSelectChange(select, 'codigo_sat_impuesto2') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Factor</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="factor_impuesto2"
                                    options={factores } 
                                    value={producto.factor_impuesto2}
                                    onChange={ (select) => { this.handleSelectChange(select, 'factor_impuesto2') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                          <div className="col-12 col-sm-3">
                            Porcentaje:
                            <Input
                              type="number"
                              step="any"
                              onChange={this.handleInputChange}
                              name={'impuesto2_porc'}
                              value={producto.impuesto2_porc}
                              style={{width : '130px'}}
                              required
                            />
                          </div>

                          <div className="col-12">
                            <div className="form-group">
                              <Label className='mt-3'>I.E.P.S:</Label>
                            </div>
                          </div>
                          <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Tipo</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="tipo_ieps"
                                    options={tipos } 
                                    value={producto.tipo_ieps}
                                    onChange={ (select) => { this.handleSelectChange(select, 'tipo_ieps') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Impuesto</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="codigo_sat_ieps"
                                    options={ieps } 
                                    value={producto.codigo_sat_ieps}
                                    onChange={ (select) => { this.handleSelectChange(select, 'codigo_sat_ieps') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                        <div className="col-12 col-md-3">
                            <FormGroup>
                                <Label>Factor</Label>
                                     <Select
                                    placeholder=""
                                    type="text"
                                    name="factor_ieps"
                                    options={factores } 
                                    value={producto.factor_ieps}
                                    onChange={ (select) => { this.handleSelectChange(select, 'factor_ieps') } }
                                    clearable={false}
                                />
                            </FormGroup>
                        </div>
                          <div className="col-12 col-sm-3">
                            <div className="form-group">
                              Procentaje
                              <Input
                                type="number"
                                step="any"
                                onChange={this.handleInputChange}
                                name={'ieps_venta_porc'}
                                value={producto.ieps_venta_porc}
                                style={{width : '130px'}}
                                required
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                   </div>
                   <div className="row">
                      
                    </div>
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.movimientocaclientes.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit" >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.props.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                { this.state.modal&&
	                <ModalTablas
	                    open={this.state.modal}
	                    toggle={this.toggle_modal}                  
	                    titulo={this.state.titulo}
	                    catalogo={this.state.tabla_modal}
	                    retorno={this.retorno}
	                    campo={this.state.campo_modal}
                      factura_id={this.props.factura_id}
	                />
	            }
                </form>
            </Modal>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        movimientocaclientes : state.movimientocaclientes,
        auth:state.auth,
        notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(FacturaModal)


// WEBPACK FOOTER //
// ./src/views/movimientoscaclientes/ProductosNota.js